module.exports = __webpack_public_path__ + "static/media/mapCliff.f024f7e3.jpg";